import { GetPageByRouteQuery } from "apollo"
import { Culture, transformProperties } from "utils"
import SmartBlocksRenderer from "../Common/SmartBlocksRenderer"
import { mergeCareerBlocks } from "./mergeCareerBlocks"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  culture: Culture
  isDriversPage?: boolean
}

export default async function CareerPage({
  data,
  locale,
  culture,
  isDriversPage = false,
}: Props): Promise<React.ReactElement> {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const mergedBlocks = mergeCareerBlocks(blocks?.blocks || [], isDriversPage)
  return (
    <SmartBlocksRenderer
      blocks={mergedBlocks}
      locale={locale}
      culture={culture}
      pageData={data}
    />
  )
}
